import { CloudinaryAsset } from "@models/cloudinary-asset.model";
import { Sanity } from "@models/sanity.model";
import DetailHero from "./detail-hero";
import DetailContent from "./detail-content";
import DetailAccordion from "./detail-accordion";
import DetailBody from "./detail-body";
import DetailSocial from "./detail-social";
import DetailTags from "./detail-tags";

export interface CatalogDetailProps {
  pageType?: string;
  heroMedia: Array<CloudinaryAsset>;
  heading: string;
  social?: Sanity.Social;
  quote?: string;
  accordion?: Sanity.Accordion;
  body: Sanity.PortableText;
  tags?: Array<string>;
  tagEyebrow?: string;
}

const CatalogDetail = ({
  pageType,
  heroMedia,
  heading,
  social,
  quote,
  accordion,
  body,
  tags,
  tagEyebrow,
}: CatalogDetailProps) => {
  return (
    <>
      <DetailHero media={heroMedia} type={pageType} />
      <DetailContent>
        <h1 className="h2">{heading}</h1>
        {accordion?.sections.length > 0 &&
          accordion.sections.map(({ title, text }, idx) => {
            return (
              <DetailAccordion
                key={idx}
                id={title.toLowerCase().split(" ").join("-")}
                label={title}
                content={text}
              />
            );
          })}

        {social && <DetailSocial content={social} />}
        {quote && <blockquote>{quote}</blockquote>}
        {body && <DetailBody content={body} />}
        {tags && <DetailTags title={tagEyebrow} content={tags} />}
      </DetailContent>
    </>
  );
};

export default CatalogDetail;
